import { MultiRadioFormFieldIconItem } from '@domgen/dgx-fe-forms/layout';

export const mockCmsApplianceDetailsNultiFieldList: MultiRadioFormFieldIconItem =
  {
    icon: 'tv',
    fieldLabel: 'Fridges & Freezers',
    fieldValue: 'CN',
  };
